import { gql } from '@apollo/client';

export const updateEraCareEventMutation = gql`
  mutation ($id: uuid!, $set: era_care_events_set_input!) {
    update_era_care_events_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
    }
  }
`;
